export enum Modes {
  Hour = 'hour',
  Day = 'day',
  Week = 'week',
  Month = 'month',
}
